import { HttpClient } from '@angular/common/http';
import { ApiResponseModel } from './../../shared/models/api-response.model';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class InquiryService {

  constructor(private http: HttpClient) { }

  getAllInquiries() {
    return this.http.get<ApiResponseModel>('api/inquiry');
  }

  getInquiry(id) {
    return this.http.get<ApiResponseModel>('api/inquiry/' + id);
  }

  changeStatus(body) {
    return this.http.patch<ApiResponseModel>('api/inquiry/status', body);
  }
}
